import React, { FC, useState } from "react";
import { t } from "i18next";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { Grid } from "@components/base";

const ProcurementWelcomeBanner: FC = () => {
  const [show, setShow] = useState(true);
  // GET PROCUREMENT DETAIL

  const onClose = (): void => {
    setShow(false);
  };

  return show ? (
    <Grid size={12}>
      <WelcomeBanner
        color="blue"
        title={t("supplier.hub.welcomeBanner.title")}
        text={t("supplier.hub.welcomeBanner.description")}
        icon="data-cloud"
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default ProcurementWelcomeBanner;
